// src/redux/reducers/paymentReducer.js

import {
    PROCESS_PAYMENT_REQUEST,
    PROCESS_PAYMENT_SUCCESS,
    PROCESS_PAYMENT_FAILURE,
    CLEAR_PAYMENT_STATUS,
  } from '../actions/paymentActions';
  
  const initialState = {
    loading: false,
    success: false,
    error: null,
  };
  
  const paymentReducer = (state = initialState, action) => {
    switch (action.type) {
      case PROCESS_PAYMENT_REQUEST:
        return {
          ...state,
          loading: true,
          success: false,
          error: null,
        };
      case PROCESS_PAYMENT_SUCCESS:
        return {
          ...state,
          loading: false,
          success: true,
          error: null,
        };
      case PROCESS_PAYMENT_FAILURE:
        return {
          ...state,
          loading: false,
          success: false,
          error: action.payload,
        };
      case CLEAR_PAYMENT_STATUS:
        return {
          ...state,
          loading: false,
          success: false,
          error: null,
        };
      default:
        return state;
    }
  };
  
  export default paymentReducer;
  